import './Base.scss';
import Delegate from "./Delegate";
import BaseObject from "./BaseObject";
import NP, {EventArgs, EventKeyArgs} from './NP';
import Font from "./Font";


interface NativeEventMetadata {
	[key: string]: Function
}

function unifyEvent (evt: any)
{
	if (evt.isFixed)
		return evt;
	evt.isFixed = true;
	if (!evt.which && typeof (evt.button) === "number")
	{
		switch (evt.button)
		{
			case 2:
				evt.which = 3;
				break;
			case 3:
				evt.which = 0;
				break;
			case 4:
				evt.which = 2;
				break;
		}
	}
	if (!evt.target)
		evt.target = evt.srcElement;
	if (evt.pageX == null && evt.clientX != null)
	{
		let y = evt.clientY + NP.getDocumentScrollTop() - (document.documentElement.clientTop || 0);
		evt.pageX = evt.clientX + NP.getDocumentScrollLeft() - (document.documentElement.clientLeft || 0);
		evt.pageY = y;
	}
	return evt;
}

export default class Control extends BaseObject {

	public EvClick: Delegate;
	public EvDragStart: Delegate;
	public EvMouseDown: Delegate;
	public EvDragEnd: Delegate;
	public EvMouseOver: Delegate;
	public EvMouseOut: Delegate;
	public EvDrag: Delegate;
	public EvSizeChanging: Delegate;
	public EvSizeChanged: Delegate;
	public EvContextMenu: Delegate;

	protected _dataKeys: object;
	protected _styleNodes: any;
	protected _root: HTMLElement;
	protected _nextNode: Node;
	protected _RK: string;
	protected _ToolTip: string;
	protected _Enabled: boolean;
	public _Content: any;
	protected _IsVisible: boolean;
	protected _Class: string;
	protected _ParentNode: HTMLElement;
	protected _Font: Font;
	protected _Left: number;
	protected _Top: number;
	protected _Right: number;
	protected _Bottom: number;
	protected _MinWidth: number;
	protected _MinHeight: number;
	protected _Parent: Control;
	protected _Tag: any;
	protected _Value: any;
	protected _ShowToolTip: boolean;
	protected _Data: object;
	protected _TabIndex: number;
	protected _isBind: boolean;
	protected _Height: number;
	protected _Width: number;
	protected _nodeIds: 0;
	protected _nodesStyles: any;
	private _touchObject: { clientY: any | number; clientX: any; target: any };

	constructor(settings?: object)
	{
		super(settings);
	}


	_initFields(settings: object)
	{
		this._RK = null;
		this._ToolTip = null;
		this._Enabled = true;
		this._Content = null;
		this._IsVisible = true;
		this._Class = null;
		this._ParentNode = null;
		this._Font = null;
		this._Left = 0;
		this._Top = 0;
		this._Right = 0;
		this._Bottom = 0;
		this._MinWidth = 0;
		this._MinHeight = 0;
		this._Parent = null;
		this._Tag = null;
		this._Value = null;

		this._ShowToolTip = true;
		this._Data = null;
		this._TabIndex = null;
		this._isBind = false;
		this._Height = null;
		this._Width = null;

		this.EvClick = new Delegate();
		this.EvDragStart = new Delegate();
		this.EvMouseDown = new Delegate();
		this.EvDragEnd = new Delegate();
		this.EvMouseOver = new Delegate();
		this.EvMouseOut = new Delegate();
		this.EvDrag = new Delegate();
		this.EvSizeChanging = new Delegate();
		this.EvSizeChanged = new Delegate();
		this.EvContextMenu = new Delegate();
		super._initFields(settings);
	}

	getRK()
	{
		return this._RK;
	}

	getEnabled()
	{
		return this._Enabled;
	}

	getContent(): any
	{
		return this._Content;
	}

	setContent(value: any)
	{
		this._Content = value;
	}


	getIsVisible()
	{
		return this._IsVisible;
	}

	getClass()
	{
		return this._Class;
	}

	getParentNode()
	{
		return this._ParentNode;
	}

	getFont()
	{
		return this._Font;
	}

	// getAnchors()
	// {
	// 	return this._Anchors;
	// }

	getLeft()
	{
		return this._Left;
	}

	getTop()
	{
		return this._Top;
	}

	getRight()
	{
		return this._Right;
	}

	getBottom()
	{
		return this._Bottom;
	}

	getMinWidth()
	{
		return this._MinWidth;
	}

	setMinWidth(value: number)
	{
		this._MinWidth = value;
	}

	getMinHeight()
	{
		return this._MinHeight;
	}

	setMinHeight(value: number)
	{
		this._MinHeight = value;
	}

	getParent()
	{
		return this._Parent;
	}

	setParent(value: Control)
	{
		this._Parent = value;
	}

	getTag()
	{
		return this._Tag;
	}

	setTag(value: any)
	{
		this._Tag = value;
	}

	getValue(): any
	{
		return this._Value;
	}

	setValue(value: any, fireEvent?: boolean)
	{
		this._Value = value;
	}


	_onContextMenu(sender: object, args: EventArgs)
	{
		this._showContextMenu(sender, args);
		let tagName = (<HTMLElement>args.Event.target).tagName;
		if (tagName != 'TEXTAREA' && tagName != 'INPUT')
			args.Event.preventDefault();
	}

	_showContextMenu(sender: object, args: EventArgs)
	{
		if (this.isLive() && this._Enabled && this.EvContextMenu)
			return this.EvContextMenu.fire(sender, args);
	}

	_onClicked(sender: object, args: EventArgs)
	{
		if (this.isLive() && this._Enabled)
			return this.EvClick.fire(sender, args);
	}

	_onDblClick(sender: Control, args: EventKeyArgs)
	{

	}

	_onKeyDown(sender: object, args: EventKeyArgs)
	{

	}

	_onKeyPress(sender: Control, args: EventKeyArgs)
	{

	}

	_onMouseDown(sender: object, args: EventArgs)
	{
		if (this.isLive() && this._Enabled)
			return this.EvMouseDown.fire(sender, args);
	}

	_onMouseOut(sender: object, args: EventArgs)
	{
		if (this.isLive() && this._Enabled)
			return this.EvMouseOut.fire(sender, args);
	}

	_onMouseOver(sender: object, args: EventArgs)
	{
		if (this.isLive() && this._Enabled)
			return this.EvMouseOver.fire(sender, args);
	}

	_initComponent(html?: string, initSize?: boolean)
	{
		if (!html)
			this._root = document.createElement("div");
		else
			this._root = NP.isString(html) ? NP.parseHTML(html) : html;

		(<any>this._root).Ctrl = this;
		if (this._Id != null)
			this._root.id = this._Id;
		if (!(NP.isNumber(this.getTabIndex())))
			this.setTabIndex(this._TabIndex);

		let font = this._Font;
		if (font)
			this.setFont(font);

		if (initSize !== false)
		{
			if (this._Width != null)
				this._root.style.width = this._Width + 'px';
			if (this._Height != null)
				this._root.style.height = this._Height + 'px';
		}

		if (this._Class)
			this.addClass(this._Class);

		if (this._ToolTip)
			this.setToolTip(this._ToolTip);
	}

	/**
	 * @deprecated
	 * @private
	 */
	_render()
	{
		this.setEnabled(this._Enabled, true);
		if (!this._IsVisible)
			this.setIsVisible(this._IsVisible);
		this.setRK(this._RK, true);
	}


	np_render(html?: string, initSize?: boolean)
	{
		this._initComponent(html, initSize);
		this.setEnabled(this._Enabled, true);
		if (!this._IsVisible)
			this.setIsVisible(this._IsVisible);
		if (this._ParentNode)
			this.putToNode(this._ParentNode);
	}

	_renderItems(items: Array<HTMLElement | Control | string>, parentNode: HTMLElement = this._root)
	{
		items.forEach(item =>
		{
			if (item)
			{
				if (item instanceof Control)
				{
					item.putToNode(parentNode)
				}
				else if (NP.isString(item))
				{
					parentNode.appendChild(NP.parseHTMLC(item));
				}
				else
					parentNode.appendChild(item as HTMLElement);
			}
		});
	}

	hasClass(className: string)
	{
		return NP.hasCssClass(this._root, className);
	}

	addClass(className: string)
	{
		if (className && this._root)
		{
			NP.addCssClass(this._root, className);
			this._Class = this._root.className;
		}
	}

	removeClass(className: string)
	{
		if (className && this._root)
		{
			NP.removeCssClass(this._root, className);
			this._Class = this._root.className;
		}
	}

	_setContentToNode(value: any, node: HTMLElement, propName?: string, reInit?: boolean)
	{
		if (!propName)
			propName = "Content";
		let propValue = (<any>this)["_" + propName];
		if (!node)
			throw new Error("Control._setContentToNode: node is null");
		if (propValue !== value || reInit)
		{
			if (propValue)
			{
				propValue = NP.toArray(propValue);
				for (let i = 0; i < propValue.length; i++)
				{
					if (propValue[i] instanceof Control)
					{
						let isVisible = propValue[i].getIsVisible();
						propValue[i].removeFD();
						if (propValue == value && reInit)
							propValue[i]._IsVisible = isVisible;
					}
					//else if (NP.IsIE && propValue[i] && propValue[i].parentNode && propValue[i].parentNode == node && propValue[i].parentNode.removeChild)
					//	propValue[i].parentNode.removeChild(propValue[i]);
				}
			}
			if (value == null)
				(<any>this)["_" + propName] = null;
			else
			{
				(<any>this)["_" + propName] = value;
				node.innerHTML = "";

				for (let elem of NP.toArray(value))
				{
					let type = typeof (elem);
					if (type == 'string' || type == 'number' || type == 'boolean')
						(<any>node).insertAdjacentHTML("beforeEnd", elem);
					else if (elem)
					{
						if (elem instanceof Control)
							elem.putToNode(node);
						else if (!(elem instanceof BaseObject))
							node.appendChild(elem);
					}
				}
			}
		}
	}

	getWidth()
	{
		return this._Width || 0;
	}

	getOffsetWidth()
	{
		if (this._Width)
			return this._Width;
		if (this._root)
		{
			this._Width = this._root.offsetWidth || 0;
			return this._Width;
		}
		return 0;
	}

	setWidth(value?: number, fireEvents?: boolean)
	{
		let args = {Width: value};
		if (fireEvents !== false)
		{
			(<any>args).Side = [NP.LTRB.Right];
			this.EvSizeChanging.fire(this, args);
		}
		if (args.Width !== this._Width)
		{
			this._Width = args.Width;
			if (NP.isNumber(this._Width) && this._Width < 0)
				this._Width = 0;
			if (this._MinWidth > 0 && this._Width < this._MinWidth)
				this._Width = this._MinWidth;
			this._root.style.width = NP.isNumber(this._Width) ? (this._Width + 'px') : '';
		}
		if (fireEvents !== false)
			this.EvSizeChanged.fire(this);
	}

	getHeight()
	{
		return this._Height || 0;
	}

	getOffsetHeight()
	{
		if (this._Height)
			return this._Height;
		if (this._root)
		{
			this._Height = this._root.offsetHeight || 0;
			return this._Height;
		}
		return 0;
	}

	setHeight(value?: number, fireEvents?: boolean)
	{
		let args = {Height: value};
		if (fireEvents !== false)
		{
			(<any>args).Side = [NP.LTRB.Bottom];
			this.EvSizeChanging.fire(this, args);
		}
		if (args.Height !== this._Height)
		{
			this._Height = args.Height;
			if (NP.isNumber(this._Height) && this._Height < 0)
				this._Height = 0;
			if (this._MinHeight > 0 && this._Height < this._MinHeight)
				this._Height = this._MinHeight;
			this._root.style.height = NP.isNumber(this._Height) ? (this._Height + 'px') : '';
		}
		if (fireEvents !== false)
			this.EvSizeChanged.fire(this);
	}

	getFocused()
	{
		return this._root === document.activeElement;
	}

	setEnabled(value: boolean, reInit?: boolean)
	{
		value = !!value;
		if (this._Enabled !== value || reInit)
		{
			this._Enabled = value;
			NP.enableNode(this._root, this._Enabled);
			if (this._Content instanceof Control)
				this._Content.setEnabled(this._Enabled, reInit);
		}
	}

	setToolTip(value: string)
	{
		this._ToolTip = value;
		if (value)
			this._root.setAttribute('title', value);
		else
			this._root.removeAttribute('title');
	}

	setTabIndex(value: number)
	{
		if (value != null)
			this._root.tabIndex = value;
		else
			this._root.removeAttribute("tabindex");
	}

	getTabIndex()
	{
		return (this._root) ? this._root.getAttribute("tabindex") : null;
	}

	setTop(value: number)
	{

		this._Top = value;
		this._root.style.top = value + "px";

	}

	setRight(value: number)
	{
		this._Right = value;
		this._root.style.right = value + "px";
	}

	setBottom(value: number)
	{
		this._Bottom = value;
		this._root.style.bottom = value + "px";
	}

	setLeft(value: number)
	{
		this._Left = value;
		this._root.style.left = value + "px";
	}


	setData(obj: any, key?: string)
	{
		if (key != undefined)
		{
			let dataKeys = <any>(this._dataKeys || (this._dataKeys = {}));
			if (obj != null)
				dataKeys[key] = obj;
			else
				delete dataKeys[key];
		}
		else
			this._Data = obj;
	}

	getData(key?: string)
	{
		if (key != undefined)
			return this._dataKeys && (<any>this._dataKeys)[key];
		else
			return this._Data;
	}

	setRK(key: string, _reInit?: boolean)
	{
		if (this._RK != key || _reInit)
		{
			this._RK = key;
			NP.RM.setToCtrl(this, key);
		}
	}

	setIsVisible(value: boolean)
	{
		this._IsVisible = value;
		this._root.style.visibility = '';
		if (value)
			NP.showNode(this._root);
		else
			NP.hideNode(this._root);
	}

	setFocus()
	{
		try
		{
			let hasTab = !!this.getTabIndex();
			if (!hasTab)
				this.setTabIndex(0);
			this._root.focus();
		} catch (e)
		{
		}
	}

	setSize(width: number, height: number, fireEvent?: boolean)
	{
		this.setWidth(width, fireEvent);
		this.setHeight(height, fireEvent);
	}

	updateSize()
	{
	}

	destroy()
	{
		if (this.isLive())
		{
			this.removeFD();
			delete this._Data;
			delete this._dataKeys;
			delete this._Tag;
			delete this._Value;
			delete this._nextNode;
			delete this._ParentNode;
			delete this._Parent;
			this._clearStyles();
			if (this._root)
				delete (<any>this._root).Ctrl;
			super.destroy();
		}
	}

	setFont(font: object)
	{
		if (this._Font && font != this._Font && this._Font instanceof Font)
			this._Font.destroy();
		this._Font = font instanceof Font ? font : new Font(font);
		if (this._root)
			this.refreshFont();
	}

	_clearStyles()
	{
		if (!this._styleNodes)
			return;
		let sn;
		while (this._styleNodes.length)
		{
			sn = this._styleNodes[0];
			this._styleNodes.splice(0, 1);
			if (sn.parentNode)
				sn.parentNode.removeChild(sn);
			sn = null;
		}
	}

	refreshFont()
	{
		if (this._Font)
			this._Font.applyToNode(this._root);
	}

	getCssStyle(node: Node, styleName: string, toNumber?: boolean, noCache?: boolean)
	{
		let n = <any>(node || this._root);
		let nodeId = n._iddd || (n._iddd = this._nodeIds++),
			 result = n.style[styleName];
		if (!result)
		{
			let ns = this._nodesStyles || (this._nodesStyles = {}),
				 nds = ns[nodeId] || (ns[nodeId] = {});
			if (nds[styleName] && nds[styleName][0] !== '0')
				result = nds[styleName];
			else
			{
				result = NP.getCssStyle(node, styleName);
				if (!noCache && result && result != "auto")
					nds[styleName] = result;
			}
		}
		if (toNumber)
		{
			result = parseFloat(result);
			if (isNaN(result))
				return 0;
		}
		return result;
	}

	resetCssCache()
	{
		this._nodesStyles = null;
	}

	getRoot()
	{
		return this._root;
	}

	show()
	{
		if (!this._IsVisible)
			this.setIsVisible(true);
		if (this._ParentNode)
		{
			if (!this._root.parentNode)
			{
				if (this._nextNode && this._nextNode.parentNode === this._ParentNode)
					this.putToNode(this._ParentNode, this._nextNode);
				else
					this.putToNode(this._ParentNode);
				delete this._nextNode;
			}
			if (!this._isBind)
				this._bindEvents();
		}
	}

	hide()
	{
		if (!this._nextNode)
		{
			this._nextNode = this._root.nextSibling;
			let p = this._ParentNode;
			this.removeFD();
			this._ParentNode = p;
			this.setIsVisible(false);
		}
	}




	_handle(event: Event)
	{
		let elem = <any>this,
			 res;
		if (elem && elem.events)
		{
			let wnd = (elem.ownerDocument == null) ? (elem.parentWindow ? elem.parentWindow : window) : elem.ownerDocument.parentWindow;
			event = event ? event : wnd.event;
			let eventObject = elem.events[event.type];
			if (eventObject)
			{
				if (eventObject.FixEvent !== false)
					event = unifyEvent(event);
				let args = {
					Event: event,
					Element: elem,
					Break: false
				};
				res = eventObject.Handle.call(eventObject.Self, eventObject.Self, args);
			}
		}
		if (res === false)
		{
			event.preventDefault();
			event.stopPropagation();
			return res;
		}
	}

	_addEvent(elem: HTMLElement, eventName: string, handler: Function, fixEv?: boolean)
	{
		let el = <any>elem;
		let events = el.events || (el.events = {});
		if (!events[eventName])
		{
			events[eventName] = {
				Handle: handler,
				Self: this,
				FixEvent: fixEv
			};
			elem.addEventListener(eventName, this._handle, false);
		}
	}

	addEvent(elem: HTMLElement, eventName: string, handler: Function, fixEv?: boolean)
	{
		this._addEvent(elem, eventName, handler, fixEv);
	}

	_addEvents(elem: HTMLElement, onEvents: NativeEventMetadata, fixEv?: boolean)
	{
		if (elem && onEvents)
			for (let eventName in onEvents)
			{
				if (onEvents.hasOwnProperty(eventName))
					this._addEvent(elem, eventName, onEvents[eventName], fixEv);
			}
	}

	_removeEvent(elem: HTMLElement, eventName: string, func: Function)
	{
		let el = <any>elem;
		if (el.events && el.events[eventName] && el.events[eventName].Handle && el.events[eventName].Handle == func)
		{
			elem.removeEventListener(eventName, this._handle, false);
			delete el.events[eventName];
		}
	}

	removeEvent(elem: HTMLElement, eventName: string, func: Function)
	{
		let el = <any>elem;
		if (el.events && el.events[eventName] && el.events[eventName].Handle && el.events[eventName].Handle == func)
		{
			elem.removeEventListener(eventName, this._handle, false);
			delete el.events[eventName];
		}
	}

	_removeAllEvents(elem: HTMLElement)
	{
		let el = <any>elem;
		if (el && el.events)
		{
			for (let eventName in el.events)
			{
				if (el.events.hasOwnProperty(eventName))
					elem.removeEventListener(eventName, this._handle, false);
			}
			delete el.events;
		}
	}

	_bindEvents()
	{
		if (!this._isBind)
		{
			this._addEvents(this._root, {
				dblclick: this._onDblClick,
				keydown: this._onKeyDown,
				keypress: this._onKeyPress,
				contextmenu: this._onContextMenu,
				mouseout: this._onMouseOut,
				mouseover: this._onMouseOver
			});

			if (NP.isTouchDevice())
				this._addEvents(this._root, {
					touchstart: this._onTouchStart,
					touchend: this._onTouchEnd
				});
			else
			{
				this._addEvents(this._root, {
					click: this._onClicked,
					mousedown: this._onMouseDown
				});
			}
			this._isBind = true;
		}
	}


	_unBindEvents()
	{
		if (this._isBind)
		{
			this._removeAllEvents(this._root);
			this._isBind = false;
		}
	}

	putToNode(node: HTMLElement, beforeNode?: Node)
	{
		if (this.isLive())
		{
			this.resetCssCache();
			if (beforeNode && beforeNode.parentNode)
				node.insertBefore(this._root, beforeNode);
			else
				node.appendChild(this._root);
			this._ParentNode = node;
			delete this._nextNode;
			if (!this._isBind)
				this._bindEvents();
		}
	}

	removeFD()
	{
		if (this._root && this._root.parentNode)
		{
			if (this._root.parentNode)
			{
				if ((<any>this._root.parentNode)._tempNode)
					return;
				this._root.parentNode.removeChild(this._root);
			}
			this._IsVisible = false;
			this._unBindEvents();
			delete this._ParentNode;
		}
	}

	_br(node?: HTMLElement)
	{
		return (node || this._root).appendChild(document.createElement("br"));
	}



	_onTouchStart(sender: object, args: any)
	{
		this._onMouseDown.apply(this, arguments);
		if (args.Event.touches && args.Event.touches[0])
		{
			this._touchObject = {
				target: args.Event.touches[0].target,
				clientX: args.Event.touches[0].clientX,
				clientY: args.Event.touches[0].clientY
			};
		}
	}

	_onTouchEnd(sender: object, args: any)
	{
		let touchObj = args.Event.changedTouches && args.Event.changedTouches[0];
		if (this._touchObject && this._touchObject.clientX != null && touchObj && touchObj.clientX != null)
		{
			let coords = NP.getMouseCoordinates(args.Event),
				 realTarget = document.elementFromPoint(coords.X, coords.Y);
			if (this._touchObject.target == touchObj.target &&
				 this._touchObject.target == realTarget &&
				 Math.abs(this._touchObject.clientX - touchObj.clientX) < 10 &&
				 Math.abs(this._touchObject.clientY - touchObj.clientY) < 10)
			{
				this._onClicked.apply(this, arguments);
			}
		}
	}

};


NP.Control = Control;

NP.setEnabled = function (items: Control[], value: boolean)
{
	items.forEach(ctrl => ctrl && ctrl instanceof Control && ctrl.setEnabled(value));
};
